module.exports = __webpack_public_path__ + "static/media/fakeStore.7bc31174.svg";